import { useQuery } from '@apollo/client';
import { AdventuresDocument } from '@flashpack/graphql';
import { useMemo } from 'react';

export type AdventureOption = { label: string; value: string };

/**
 * Autocomplete options for every active adventure except the current one, labelled with the
 * Booking Engine tour code and title.
 */
export const useOtherAdventureOptions = (
  currentAdventureId: string,
  { skip = false }: { skip?: boolean } = {},
) => {
  const { data, loading } = useQuery(AdventuresDocument, { skip });

  const options = useMemo<AdventureOption[]>(
    () =>
      (data?.adventures ?? [])
        .filter(({ id, archived }) => id !== currentAdventureId && !archived)
        .map(({ id, bookingEngineTourCode, title }) => ({
          value: id,
          label: title ? `${bookingEngineTourCode} - ${title}` : bookingEngineTourCode,
        }))
        .sort((a, b) => a.label.localeCompare(b.label)),
    [data?.adventures, currentAdventureId],
  );

  return { options, loading };
};
